import { executeStandardRequest } from '@musinsa/packages-http';
import { privateHttpClient } from '../httpClient';
import { salesRankingQueryKeys } from './queryKeys';
import type { GetProductSalesRankingResponse } from './types';

// SalesRankingSortOption은 먼저 정의되어야 합니다.
export type SalesRankingSortOption = 'TOTAL_COMMISSION' | 'TOTAL_QUANTITY';

/**
 * @description 판매 상품 랭킹 조회 요청 (Query Parameters)
 */
export interface GetProductSalesRankingRequestParams {
  year: number;
  month: number;
  page?: number;
  size?: number;
  sort?: SalesRankingSortOption;
}

export const getProductSalesRanking = (params: GetProductSalesRankingRequestParams) =>
  executeStandardRequest(() =>
    privateHttpClient.get<GetProductSalesRankingResponse>(
      salesRankingQueryKeys.getProductSalesRanking,
      params,
    ),
  );
